<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title>{{ $t("claimTitle") }}</v-toolbar-title>
      <v-btn @click="toggleLocale"
        >{{ $t("language") }} ({{ $i18n.locale }})</v-btn
      >
    </v-app-bar>

    <v-main>
      <v-container>
        <h2>{{ $t("roadProtectionText") }}</h2>
        <v-card class="pa-4 mb-4">
          <v-card-text>
            <v-card-title class="text-h6 mb-2">{{
              $t("searchRegistration")
            }}</v-card-title>
            <v-form @submit.prevent="searchRegistration">
              <v-text-field
                v-model="vehicleRegistrationNo"
                :label="$t('searchClaimPlaceholder')"
                required
                :disabled="loading"
              ></v-text-field>
              <v-btn
                type="submit"
                color="primary"
                block
                :loading="loading"
                :disabled="loading"
              >
                {{ $t("search") }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card v-if="tyreInfo" class="pa-4 mb-4">
          <v-card-text>
            <p>
              {{ $t("carLicensePlate") }}: {{ tyreInfo.vehicleRegistrationNo }}
            </p>
            <p>
              {{ $t("purchaseDate") }}: {{ formatDate(tyreInfo.purchaseDate) }}
            </p>
            <v-divider class="my-4"></v-divider>
            <h3 class="mb-3">{{ $t("purchasedTyreSize") }}</h3>
            <v-simple-table class="tyre-table">
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="(tyre, index) in tyreInfo.tyreList"
                    :key="index"
                    class="tyre-row"
                  >
                    <td class="tyre-info-cell">
                      <div class="tyre-info-line">{{ tyre.tireline }}</div>
                      <div class="tyre-info-size">{{ tyre.tireSize }}</div>
                    </td>
                    <td class="tyre-info-cell checkbox-cell">
                      <div class="custom-checkbox-container">
                        <span class="checkbox-label">{{
                          $t("claimRequest")
                        }}</span>
                        <v-checkbox
                          v-model="tyre.checked"
                          hide-details
                          class="ma-0 pa-0"
                          density="compact"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="tyre-info-cell upload-cell">
                      <v-file-input
                        v-if="tyre.checked"
                        v-model="tyre.files"
                        :label="$t('uploadPhotos')"
                        multiple
                        accept="image/*"
                        prepend-icon="mdi-camera"
                        @change="handleFileUpload(index)"
                        hide-details
                        class="ma-0 pa-0"
                      ></v-file-input>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-btn
            color="green"
            block
            :loading="loading"
            :disabled="!canSubmitClaim"
            @click="submitClaim"
          >
            {{ $t("submitClaim") }}
          </v-btn>
        </v-card>

        <v-snackbar v-model="showError" color="error" :timeout="3000">
          {{ errorMessage }}
        </v-snackbar>

        <v-dialog v-model="showSuccessDialog" persistent max-width="400">
          <v-card>
            <v-card-text>{{ $t("claimSubmittedSuccessfully") }}</v-card-text>
            <v-card-text>{{ $t("notGuaranteeClaim") }}</v-card-text>
            <v-card-text>{{ $t("contactUs") }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="handleSuccessDialogClose"
              >
                {{ $t("ok") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "TyreClaim",
  data() {
    return {
      vehicleRegistrationNo: "",
      tyreInfo: null,
      loading: false,
      showError: false,
      showSuccessDialog: false,
      errorMessage: "",
    };
  },
  computed: {
    canSubmitClaim() {
      if (!this.tyreInfo || !this.tyreInfo.tyreList) return false;

      const checkedTyres = this.tyreInfo.tyreList.filter(
        (tyre) => tyre.checked
      );
      if (checkedTyres.length === 0) return false;

      return checkedTyres.every((tyre) => tyre.files && tyre.files.length > 0);
    },
    checkedTyresCount() {
      return this.tyreInfo
        ? this.tyreInfo.tyreList.filter((tyre) => tyre.checked).length
        : 0;
    },
    tyresWithImagesCount() {
      return this.tyreInfo
        ? this.tyreInfo.tyreList.filter(
            (tyre) => tyre.checked && tyre.files && tyre.files.length > 0
          ).length
        : 0;
    },
  },
  methods: {
    async searchRegistration() {
      this.loading = true;
      this.tyreInfo = null;
      try {
        const response = await axios.get(
          "https://tyremanagementwebhost20240620094429.azurewebsites.net/api/services/app/Configuration/GetTyreRegistration",
          {
            params: { VehicleRegistrationNo: this.vehicleRegistrationNo },
            headers: {
              accept: "text/plain",
              Authorization: "null",
              "X-XSRF-TOKEN":
                "CfDJ8MPgAadcK_ZLh8mY9f_PY3SungQmQtvuUhsGl1fLLyfKQu9GBLPLjptQhNhgkiAc80nWnYLi507CqRiOO9LKbWMPVTibtE7i2ty2OgT3y8ZnlMW2IgsjK1JztWvu4FuigMWCpOIXplQdinO4mfpAPck",
            },
          }
        );
        this.tyreInfo = response.data.result;
        this.tyreInfo.tyreList = this.tyreInfo.tyreList.map((tyre) => ({
          ...tyre,
          checked: false,
          files: [],
        }));
        console.log("Tyre registration:", this.tyreInfo);
      } catch (error) {
        console.error("Error fetching tyre registration:", error);
        this.errorMessage = this.$t("errorFetchingData");
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },

    async submitClaim() {
      console.log("submitClaim method called");
      console.log("Current tyreInfo:", JSON.stringify(this.tyreInfo, null, 2));

      if (!this.canSubmitClaim) {
        console.log(
          "Cannot submit claim. Checked tyres:",
          this.checkedTyresCount,
          "Tyres with images:",
          this.tyresWithImagesCount
        );
        this.errorMessage = this.$t("errorMissingImages");
        this.showError = true;
        return;
      }

      this.loading = true;
      try {
        const formData = new FormData();
        const checkedTyres = this.tyreInfo.tyreList.filter(
          (tyre) => tyre.checked
        );

        checkedTyres.forEach((tyre) => {
          formData.append("TyreId", tyre.id.toString());
          tyre.files.forEach((file) => {
            formData.append("TyreImage", file);
          });
        });

        formData.append(
          "TyreRegistrationId",
          this.tyreInfo.tyreRegistrationId.toString()
        );

        console.log("Submitting claim with formData:", formData);

        const response = await axios.post(
          "https://tyremanagementwebhost20240620094429.azurewebsites.net/api/services/app/Configuration/PostTyreClaim",
          formData,
          {
            headers: {
              accept: "text/plain",
              "Content-Type": "multipart/form-data",
              Authorization: "null",
              "X-XSRF-TOKEN":
                "CfDJ8MPgAadcK_ZLh8mY9f_PY3RBlSEm6KETVnYDYPSybjQWTTTp8xogjaSvGyC5epJCbYrckIpgxCAo3__VRijPKnbXaJCEchy7tiHCJb7nQCYTv6yn4fyk4Pp4MKufh6fVfYeVpAqGYXBxFNr6X7-oz6g",
            },
          }
        );

        console.log("Claim submitted successfully:", response.data);
        this.showSuccessDialog = true;
      } catch (error) {
        console.error("Error submitting claim:", error);
        this.errorMessage = this.$t("errorSubmittingClaim");
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },

    handleFileUpload(index) {
      console.log(
        "Files uploaded for tyre",
        index,
        ":",
        this.tyreInfo.tyreList[index].files
      );
    },

    toggleLocale() {
      this.$i18n.locale = this.$i18n.locale === "en" ? "zh" : "en";
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(this.$i18n.locale);
    },

    handleSuccessDialogClose() {
      this.showSuccessDialog = false;
      this.$router.go(-1); // Go back to the previous page
    },
  },
};
</script>

<style scoped>
.v-card-title {
  word-break: keep-all;
}

.tyre-info-cell {
  padding: 12px;
  border: 1px solid #e0e0e0;
}

.tyre-info-line {
  font-weight: bold;
  margin-bottom: 4px;
}

.tyre-info-size {
  color: #666;
}

.checkbox-cell {
  width: 150px;
}

.upload-cell {
  min-width: 200px;
}

.upload-cell :deep(.v-input__control) {
  width: 100%;
}

.upload-cell :deep(.v-label) {
  white-space: normal;
  word-break: break-word;
  opacity: 1;
}

.custom-checkbox-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.checkbox-label {
  margin-right: 12px;
}
</style>
